import { defaultThemeOptions } from 'theme/options';

const color = defaultThemeOptions.palette?.background?.default;

export const gradients = {
  bottomToTop: {
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%) /*! @noflip */',
  },
  citiesCard: {
    background:
      'linear-gradient(180deg, rgba(0,0,0,0) 55%, #000000 100%) /*! @noflip */',
  },
  citiesCardEmpty: {
    filter: 'grayscale(100%)',
  },
  horizontalListChevronLeft: {
    background: `linear-gradient(90deg, ${color} 0%, rgba(0, 0, 0, 0.00) 100%) /*! @noflip */`,
  },
  horizontalListChevronRight: {
    background: `linear-gradient(270deg, ${color} 0%, rgba(0, 0, 0, 0.00) 100%) /*! @noflip */`,
  },
};
